<section>
  <p-card>
    <div class="text-center" [style.background-color]="heroBackgroundColor">
      <img
        *ngIf="heroImageDesktop"
        class="sm:hidden md:hidden lg:inline heroDesktop"
        src="{{ heroImageDesktop }}"
        alt="{{ heroImageAlt }}"
        data-autoid="hero-desktop"
        [style.padding]="heroPadding"
      />
      <img
        *ngIf="heroImageTablet"
        class="sm:hidden md:inline lg:hidden heroTablet"
        src="{{ heroImageTablet }}"
        alt="{{ heroImageAlt }}"
        data-autoid="hero-tablet"
        [style.padding]="heroPadding"
      />
      <img
        *ngIf="heroImageMobile"
        class="sm:inline md:hidden lg:hidden heroMobile"
        src="{{ heroImageMobile }}"
        alt="{{ heroImageAlt }}"
        data-autoid="hero-mobile"
        [style.padding]="heroPadding"
      />
    </div>
    <div>
      <h2 *ngIf="title" class="card-title" data-autoid="cinch-card-title">
        {{ title }}
      </h2>
      <h3
        *ngIf="subtitle"
        class="card-subtitle"
        data-autoid="cinch-card-subtitle"
      >
        {{ subtitle }}
      </h3>
      <ng-content></ng-content>
    </div>
  </p-card>
</section>
